import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PushToDeviceService {

  constructor(private http: HttpClient,
    public configService: ConfigurationService) {
  }

  get sequencersUrl(): string {
    let region = this.configService.getSelectedRegion();
    return this.configService.getConfig(region).siteSequencerUrl;
  }
  
  getDeviceHierarchy(siteRef: string, sequenceId: string) {
   return this.http.get(this.sequencersUrl + `/device-mgmt/hierarchy?siteRef=${siteRef}&seqId=${sequenceId}`).pipe(catchError(this.handleError));
  }

  applySequence(seqId: string, payload: any) {
    return this.http.put(this.sequencersUrl + `/device-seq/apply?seqId=${seqId}`, payload).pipe(catchError(this.handleError));
  }

  getSequenceDeliveryLogs(seqId: string, siteId: string) {
    return this.http.get(this.sequencersUrl + `/device-mgmt/deliveryLogs?seqId=${seqId}&siteId=${siteId}`).pipe(catchError(this.handleError));
  }

  getSequenceDebugInfo(seqId: string) {
    return this.http.get(this.sequencersUrl + `/device-mgmt/debugInfo?seqId=${seqId}`).pipe(catchError(this.handleError));
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error);
  }

}
